<template>
  <div class="w400">
    <el-form class="pop-form-wrap" label-width="100px" :model="formData" ref="commonForm" v-if="formData">
      <el-form-item label="Menu Type" prop="MoType">
        <el-select v-model="formData.MoType" placeholder="Please Select">
          <el-option v-for="(item, i) in config.navGroup" :key="i" :label="item.label" :value="item.groupCode">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Superior Menu" prop="MoFacode" v-if="!formData.Id">
        <tree-select :treeData="treeData" :treeProps="moduleProp" v-model="formData.MoFacode" :multiple="false" placeholder="请选择" @errorCallback="showTreeError" @setSelectedId="setSelectedId">
        </tree-select>
      </el-form-item>
      <el-form-item label="Name" prop="MoName">
        <el-input size="small" v-model="formData.MoName"></el-input>
      </el-form-item>
      <el-form-item label="Logo" prop="MoLogo">
        <div class="icon-select-wrap hf">
          <el-row>
            <el-col :span="4" v-for="(item, i) in iconList" :key="i">
              <div class="item ftp" :class="{ active:item === formData.MoLogo }" @click="selectLogo(item)">
                <span class="fa" :class="item"></span>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-form-item>
      <el-form-item label="Describe" prop="MoDescribe">
        <el-input size="small" v-model="formData.MoDescribe"></el-input>
      </el-form-item>
      <el-form-item label="Sort" prop="MoSort">
        <el-input size="small" v-model.number="formData.MoSort"></el-input>
      </el-form-item>
      <el-form-item label="Is Leaf" prop="IsLeaf">
        <el-switch v-model="formData.IsLeaf" on-text="" off-text=""></el-switch>
      </el-form-item>
      <el-form-item label="URL" prop="MoUrl" v-show="formData.IsLeaf">
        <el-input size="small" v-model="formData.MoUrl"></el-input>
      </el-form-item>
      <el-form-item>
        <div class="pop-center-btn-wrap">
          <el-button type="primary" @click="doAdd('commonForm')" v-if='!formData.Id'>add</el-button>
          <el-button type="primary" @click="doUpdate('commonForm')" v-if='formData.Id'>save</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import config from '@/components/common/config'
import tools from '@/components/common/tools'
import tree from '@/components/common/tree'

// import storeTools from '@/store/tools'

import treeSelect from '@/libcomponents/tree-select/tree.vue'

// 数据对象
let dataStore = tools.createDataStore({
  // 父亲节点CODE
  MoFacode: '',
  // 菜单类型
  MoType: '',
  // 菜单名称
  MoName: '',
  // 菜单图标
  MoLogo: '',
  // 菜单描述
  MoDescribe: '',
  // 菜单Sort
  MoSort: '',
  // 是否叶子节点
  IsLeaf: false,
  // 菜单URL
  MoUrl: ''
})

// 请求相关操作
let page = {
  methods: {
    // add操作
    addDataAjax() {
      let data = tools.getModel(this.formData)
      data.IsLeaf = data.IsLeaf ? 1 : 0
      tools.commonAjax.call(this, true, '/SystemManage/AddModule', data).then(() => {
        this.$message.success('Operate success!')
        // add成功
        this.$emit('addSuccess')
      })
    },
    // 修改操作
    updateDataAjax(id, state) {
      let data = tools.getModel(this.formData)
      data.IsLeaf = data.IsLeaf ? 1 : 0
      tools.commonAjax.call(this, true, '/SystemManage/UpdateModule', data).then(() => {
        this.$message.success('Operate success!')
        // 修改成功
        this.$emit('updateSuccess')
        // 重新获取登录用户信息
        this.$store.dispatch('getLoginMemberInfo', false)
      })
    }
  }
}

// 菜单树
let moduleTree = new tree.TreeCreate(function(item) {
  for (let key in item) {
    if (item.hasOwnProperty(key)) {
      this[key] = item[key]
    }
  }
}, { FId: 'MoFacode', Id: 'MoCode', rootId: '-1' })

export default {
  name: 'ModuleForm',
  componentName: 'ModuleForm',
  mixins: [page],
  components: {
    treeSelect
  },
  props: [
    'moduleData',
    'moduleProp'
  ],
  data() {
    return {
      config: config,
      formData: dataStore.getDefaultData(),
      iconList: [
        'fa-image',
        'fa-inbox',
        'fa-rss',
        'fa-search',
        'fa-folder-o',
        'fa-bug',
        'fa-calendar-check-o',
        'fa-cog',
        'fa-tags',
        'fa-user-o',
        'fa-file-o',
        'fa-align-left',
        'fa-paperclip',
        'fa-gg',
        'fa-slack',
        'fa-skyatlas',
        'fa-html5'
      ]
    }
  },
  computed: {
    // 侧边树数据
    treeData() {
      let treeFlatData = this.moduleData.filter(item => {
        return !item.IsLeaf
      })
      moduleTree.create(treeFlatData)
      let treeData = moduleTree.getTreeData()
      return treeData
    }
  },
  methods: {
    showTreeError(error) {
      this.$message.info(error.message)
    },
    setSelectedId(val) {
      this.formData.MoFacode = val
    },
    // 重置表单值
    resetValue() {
      this.formData = dataStore.getDefaultData()
    },
    // 设置表单值
    setValue(value) {
      this.formData = tools.extendData(dataStore.getDefaultData(), value || {})
      this.formData.IsLeaf = !!this.formData.IsLeaf
    },
    // 发布
    doAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addDataAjax()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 修改
    doUpdate(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updateDataAjax()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 选择菜单图标
    selectLogo(val) {
      this.formData.MoLogo = val
    }
  }
}
</script>

<style lang="scss">
@import "~@/style/lib-config";
.icon-select-wrap {
  .item {
    width: 100%;
    padding: 0 5px;
    font-size: 18px;
    text-align: center;
    cursor: pointer;
    &.active {
      span {
        background-color: $c_nc_3;
        border-radius: 3px;
      }
    }
    span {
      width: 100%;
      line-height: 26px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// ModuleForm.vue?0abdb226